import { Sparkles } from "lucide-react";

export default function OriginalBadge({ size = "sm", className = "" }) {
  const dim = size === "lg" ? "px-3 py-1.5 text-[11px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid="ovamx-original-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-coral via-coral-hover to-ink text-cream font-mono uppercase tracking-[0.18em] ${dim} ${className}`}
    >
      <Sparkles className="w-3 h-3" strokeWidth={2.2} />
      Ovamx Original
    </span>
  );
}
